var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { useEffect, useRef, useState } from 'react';
import { Form } from 'react-final-form';
import { Button, DropdownClose, DropdownDownArrow, FFAsyncDropdown, FFDropdown, FFTextInput, GBTypography, TextInput } from '@leapfinance/geebee-component-library';
import { Divider, IconButton, Popover } from '@mui/material';
import classNames from 'classnames';
import { isEqual } from 'lodash';
import useFinalFormYupFormHelpers from '../../../../helpers/finalform/useFinalFormYupFormHelpers';
import { isFalsy } from '../../../../utils/common';
import { EnglishExamStatusEnum, EnglishExamStatusOptions, fieldToLabelMapping, getModifiedGradeLabel, gradeOptions } from '../utils';
import { eligibilityEnglishExamSchema } from './schema/eligibility.schema';
import { Inputype } from './types';
import usePrevious from './usePrevious';
var EnglishExamCFFilter = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    var _s = __read(useFinalFormYupFormHelpers({
        schema: eligibilityEnglishExamSchema
    }), 2), validate = _s[0], formNames = _s[1];
    var prevInitialProps = usePrevious(props.initialValues);
    var _t = __read(React.useState(null), 2), anchorEl = _t[0], setAnchorEl = _t[1];
    var _u = __read(useState(), 2), errorMessage = _u[0], setErrorMessage = _u[1];
    var open = Boolean(anchorEl);
    var id = open ? 'university-english-filter-popover' : undefined;
    var inputRef = useRef(null);
    var formRef = useRef();
    useEffect(function () {
        if (isEqual(prevInitialProps, props.initialValues))
            return;
        eligibilityEnglishExamSchema === null || eligibilityEnglishExamSchema === void 0 ? void 0 : eligibilityEnglishExamSchema.validate(props === null || props === void 0 ? void 0 : props.initialValues, { abortEarly: false }).then(function () {
            setErrorMessage('');
        }).catch(function (err) {
            var errorFields = [];
            err.inner.forEach(function (e) {
                errorFields.push(e.path);
            });
            if (isFalsy(errorFields))
                return;
            var message = errorFields.map(function (field) { return fieldToLabelMapping === null || fieldToLabelMapping === void 0 ? void 0 : fieldToLabelMapping[field]; }).join(', ');
            setErrorMessage("Invalid ".concat(message));
        });
    }, [props === null || props === void 0 ? void 0 : props.initialValues]);
    useEffect(function () {
        if (open && !!errorMessage) {
            // submit the form so the errors are visible on opening
            setTimeout(function () {
                var _a;
                (_a = formRef === null || formRef === void 0 ? void 0 : formRef.current) === null || _a === void 0 ? void 0 : _a.submit();
            }, 0);
        }
    }, [open]);
    var triggerSectionEvent = function (title, type) {
        // CfEventUtil.triggerCfEvent(CFEventsType.ELIGIBLITY_SECTION, {
        //   name: `English Exam - ${title}`,
        //   restInfo: {
        //     format: type
        //   }
        // });
    };
    var handleClose = function () {
        setAnchorEl(null);
        setTimeout(function () {
            var _a;
            (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
        }, 0);
    };
    var handleFormSubmit = function (values) {
        var _a, _b, _c, _d, _e;
        var examType = (_a = values === null || values === void 0 ? void 0 : values.englishExamType) === null || _a === void 0 ? void 0 : _a.value;
        var noValuesAppliedInEnglishExam = examType === 'DUOLINGO'
            ? isFalsy(values === null || values === void 0 ? void 0 : values.comprehension) &&
                isFalsy(values === null || values === void 0 ? void 0 : values.production) &&
                isFalsy(values === null || values === void 0 ? void 0 : values.conversation) &&
                isFalsy(values === null || values === void 0 ? void 0 : values.literacy) &&
                isFalsy(values === null || values === void 0 ? void 0 : values.englishTotalScore)
            : isFalsy(values === null || values === void 0 ? void 0 : values.reading) &&
                isFalsy(values === null || values === void 0 ? void 0 : values.writing) &&
                isFalsy(values === null || values === void 0 ? void 0 : values.speaking) &&
                isFalsy(values === null || values === void 0 ? void 0 : values.listening) &&
                isFalsy(values === null || values === void 0 ? void 0 : values.englishTotalScore);
        var noValuesAppliedInPlanningExam = isFalsy(values === null || values === void 0 ? void 0 : values.englishTotalScore);
        // const noValuesAppliedInExamWaiver =
        //   isFalsy(values?.ugUniversityCode) &&
        //   isFalsy(values?.twelfthEnglishGrade) &&
        //   isFalsy(values?.twelfthGraduationYear) &&
        //   isFalsy(values?.twelfthBoardCode);
        var isEnglishExamGivenChosen = ((_b = values === null || values === void 0 ? void 0 : values.englishExamStatus) === null || _b === void 0 ? void 0 : _b.value) === EnglishExamStatusEnum.GIVEN;
        var isPlanningToGiveEnglishExam = ((_c = values === null || values === void 0 ? void 0 : values.englishExamStatus) === null || _c === void 0 ? void 0 : _c.value) === EnglishExamStatusEnum.PLANNING_TO_GIVE;
        // const isExamWaiverChosen = values?.englishExamStatus?.value === EnglishExamStatusEnum.ENGLISH_EXAM_WAIVER;
        var newValues = __assign(__assign({}, values), { reading: values === null || values === void 0 ? void 0 : values.reading, writing: values === null || values === void 0 ? void 0 : values.writing, speaking: values === null || values === void 0 ? void 0 : values.speaking, listening: values === null || values === void 0 ? void 0 : values.listening, comprehension: values === null || values === void 0 ? void 0 : values.comprehension, production: values === null || values === void 0 ? void 0 : values.production, conversation: values === null || values === void 0 ? void 0 : values.conversation, literacy: values === null || values === void 0 ? void 0 : values.literacy, englishTotalScore: values === null || values === void 0 ? void 0 : values.englishTotalScore, englishExamType: noValuesAppliedInEnglishExam ? null : values === null || values === void 0 ? void 0 : values.englishExamType, twelfthEnglishGradingScheme: isFalsy(values === null || values === void 0 ? void 0 : values.twelfthEnglishGrade) ? null : values === null || values === void 0 ? void 0 : values.twelfthEnglishGradingScheme, moiAccepted: ((_d = values === null || values === void 0 ? void 0 : values.englishExamStatus) === null || _d === void 0 ? void 0 : _d.value) === EnglishExamStatusEnum.ENGLISH_EXAM_WAIVER ? 'true' : undefined, englishExamStatus: (isEnglishExamGivenChosen && noValuesAppliedInEnglishExam) ||
                (isPlanningToGiveEnglishExam && noValuesAppliedInPlanningExam)
                ? null
                : values === null || values === void 0 ? void 0 : values.englishExamStatus });
        (_e = props === null || props === void 0 ? void 0 : props.onApply) === null || _e === void 0 ? void 0 : _e.call(props, newValues);
        handleClose();
    };
    var clearFilters = function () {
        handleFormSubmit({
            comprehension: null,
            conversation: null,
            englishExamType: null,
            englishTotalScore: null,
            listening: null,
            literacy: null,
            production: null,
            reading: null,
            speaking: null,
            writing: null,
            englishExamStatus: null,
            ugUniversityCode: null,
            twelfthEnglishGradingScheme: null,
            twelfthBoardCode: null,
            twelfthEnglishGrade: null,
            twelfthGraduationYear: null
        });
    };
    var englishExamGivenValues = [
        (_a = props === null || props === void 0 ? void 0 : props.initialValues) === null || _a === void 0 ? void 0 : _a.englishTotalScore,
        (_b = props === null || props === void 0 ? void 0 : props.initialValues) === null || _b === void 0 ? void 0 : _b.reading,
        (_c = props === null || props === void 0 ? void 0 : props.initialValues) === null || _c === void 0 ? void 0 : _c.writing,
        (_d = props === null || props === void 0 ? void 0 : props.initialValues) === null || _d === void 0 ? void 0 : _d.listening,
        (_e = props === null || props === void 0 ? void 0 : props.initialValues) === null || _e === void 0 ? void 0 : _e.speaking,
        (_f = props === null || props === void 0 ? void 0 : props.initialValues) === null || _f === void 0 ? void 0 : _f.comprehension,
        (_g = props === null || props === void 0 ? void 0 : props.initialValues) === null || _g === void 0 ? void 0 : _g.conversation,
        (_h = props === null || props === void 0 ? void 0 : props.initialValues) === null || _h === void 0 ? void 0 : _h.production,
        (_j = props === null || props === void 0 ? void 0 : props.initialValues) === null || _j === void 0 ? void 0 : _j.literacy
    ];
    var englishExamPlanningToGiveValues = [(_k = props === null || props === void 0 ? void 0 : props.initialValues) === null || _k === void 0 ? void 0 : _k.englishTotalScore];
    // const englishExamWaiverValues = [
    //   props?.initialValues?.ugUniversityCode,
    //   props?.initialValues?.twelfthBoardCode,
    //   props?.initialValues?.twelfthEnglishGrade,
    //   props?.initialValues?.twelfthGraduationYear
    // ];
    var isEnglishExamGivenChosen = ((_m = (_l = props === null || props === void 0 ? void 0 : props.initialValues) === null || _l === void 0 ? void 0 : _l.englishExamStatus) === null || _m === void 0 ? void 0 : _m.value) === EnglishExamStatusEnum.GIVEN;
    var isPlanningToGiveEnglishExam = ((_p = (_o = props === null || props === void 0 ? void 0 : props.initialValues) === null || _o === void 0 ? void 0 : _o.englishExamStatus) === null || _p === void 0 ? void 0 : _p.value) === EnglishExamStatusEnum.PLANNING_TO_GIVE;
    var isExamWaiverChosen = ((_r = (_q = props === null || props === void 0 ? void 0 : props.initialValues) === null || _q === void 0 ? void 0 : _q.englishExamStatus) === null || _r === void 0 ? void 0 : _r.value) === EnglishExamStatusEnum.ENGLISH_EXAM_WAIVER;
    var examGivenLabel = (englishExamGivenValues === null || englishExamGivenValues === void 0 ? void 0 : englishExamGivenValues.every(isFalsy)) ? '' : 'Given';
    var examPlanningLabel = (englishExamPlanningToGiveValues === null || englishExamPlanningToGiveValues === void 0 ? void 0 : englishExamPlanningToGiveValues.every(isFalsy)) ? '' : 'Planning to Give';
    var examWaiverLabel = 'English Exam Waiver';
    var displayValue = (isEnglishExamGivenChosen && examGivenLabel) ||
        (isPlanningToGiveEnglishExam && examPlanningLabel) ||
        (isExamWaiverChosen && examWaiverLabel) ||
        '';
    return (React.createElement(React.Fragment, null,
        React.createElement(TextInput, { "data-hasValue": !isFalsy(displayValue), label: "English Exam", keepDefaultLabelBehaviour: true, className: classNames('lfc-w-[190px]  lfc-transition-all '), InputLabelProps: { shrink: open || !!displayValue }, helperText: errorMessage, error: !!errorMessage, value: displayValue, size: "small", InputProps: {
                readOnly: true,
                endAdornment: (React.createElement(React.Fragment, null,
                    displayValue ? (React.createElement(IconButton, { onClick: function (event) {
                            event.stopPropagation();
                            clearFilters();
                        } },
                        React.createElement(DropdownClose, { size: "small" }))) : null,
                    React.createElement(DropdownDownArrow, { size: "small", classNames: classNames('', { 'lfc-rotate-180': open }) }))),
                sx: function (theme) {
                    var _a, _b, _c, _d, _e;
                    return displayValue && !open
                        ? {
                            '&.MuiOutlinedInput-root': {
                                backgroundColor: (_a = theme.palette.primary) === null || _a === void 0 ? void 0 : _a['200'],
                                fieldSet: {
                                    borderColor: (_b = theme.palette.primary) === null || _b === void 0 ? void 0 : _b['500']
                                },
                                ':hover': {
                                    backgroundColor: (_c = theme.palette.primary) === null || _c === void 0 ? void 0 : _c['200']
                                    // fieldSet: {
                                    //   borderColor: theme.palette.primary?.['500']
                                    // }
                                },
                                '.MuiInputAdornment-positionStart': {
                                    '.MuiTypography-root': {
                                        color: (_d = theme.palette.primary) === null || _d === void 0 ? void 0 : _d['500']
                                    }
                                },
                                input: {
                                    textOverflow: 'ellipsis',
                                    color: (_e = theme.palette.primary) === null || _e === void 0 ? void 0 : _e['500']
                                }
                            }
                        }
                        : {
                            '&.MuiOutlinedInput-root': {
                                backgroundColor: 'white'
                            }
                        };
                }
            }, onClick: function (event) {
                if (!anchorEl) {
                    setAnchorEl(event.currentTarget);
                }
            }, inputRef: inputRef }),
        React.createElement(Popover, { id: id, open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left'
            }, transformOrigin: { vertical: 0, horizontal: 0 }, slotProps: { paper: { sx: { overflow: 'visible' }, elevation: 0 } }, className: "lfc-mt-1 " },
            React.createElement(Form, { validate: validate, initialValues: props === null || props === void 0 ? void 0 : props.initialValues, render: function (_a) {
                    var _b, _c, _d, _e, _f, _g;
                    var handleSubmit = _a.handleSubmit, form = _a.form, values = _a.values;
                    formRef.current = form;
                    var examType = (_b = values === null || values === void 0 ? void 0 : values.englishExamType) === null || _b === void 0 ? void 0 : _b.value;
                    var examStatus = (_c = values === null || values === void 0 ? void 0 : values.englishExamStatus) === null || _c === void 0 ? void 0 : _c.value;
                    var gradingScheme = (_d = values === null || values === void 0 ? void 0 : values.twelfthEnglishGradingScheme) === null || _d === void 0 ? void 0 : _d.value;
                    var twelfthBoard = (_e = values === null || values === void 0 ? void 0 : values.twelfthBoardCode) === null || _e === void 0 ? void 0 : _e.value;
                    return (React.createElement("div", { className: "lfc-w-[380px] lfc-max-h-[500px] lfc-flex lfc-flex-col lfc-gap-6  lfc-pt-4  lfc-rounded-md lfc-border lfc-shadow-lg lfc-overflow-y-auto" },
                        React.createElement("div", { className: "lfc-px-4" },
                            React.createElement("div", { className: "lfc-flex lfc-gap-2 lfc-items-center lfc-bg-gbTokens-sapphire-200 lfc-py-1 lfc-px-2 lfc-rounded-md" },
                                React.createElement("div", null,
                                    React.createElement("i", { className: "fi fi-rr-square-info" })),
                                React.createElement(GBTypography, { variant: "caption1" }, "Select an English Exam given by the student and enter the scores to filter courses based on eligibility."))),
                        React.createElement("div", { className: "lfc-flex lfc-flex-col lfc-px-4 lfc-gap-2" },
                            React.createElement(FFDropdown, { fieldProps: { name: formNames.englishExamStatus }, componentProps: {
                                    options: EnglishExamStatusOptions !== null && EnglishExamStatusOptions !== void 0 ? EnglishExamStatusOptions : [],
                                    disableClearable: false,
                                    onChange: function (_, value) {
                                        // form.batch(() => {
                                        //   Object.values(formNames).forEach((name) => {
                                        //     if (name === formNames.englishExamStatus) return;
                                        //     form.change(name as any, undefined);
                                        //   });
                                        //   form.change(formNames.englishExamStatus as any, value);
                                        // });
                                        form.change(formNames.englishExamStatus, value);
                                    },
                                    textInputProps: {
                                        label: 'English exam Status',
                                        placeholder: 'Select the exam status'
                                    },
                                    size: 'small'
                                } }),
                            [EnglishExamStatusEnum.GIVEN, EnglishExamStatusEnum.PLANNING_TO_GIVE].includes(examStatus) ? (React.createElement(FFDropdown, { fieldProps: { name: formNames.englishExamType }, componentProps: {
                                    options: (_f = props === null || props === void 0 ? void 0 : props.englishExamOptions) !== null && _f !== void 0 ? _f : [],
                                    disableClearable: false,
                                    onChange: function (_, value) {
                                        triggerSectionEvent('English exam', Inputype.DROPDOWN);
                                        form.batch(function () {
                                            Object.values(formNames).forEach(function (name) {
                                                if (name === formNames.englishExamStatus)
                                                    return;
                                                form.change(name, undefined);
                                            });
                                            form.change(formNames.englishExamType, value);
                                        });
                                    },
                                    textInputProps: {
                                        label: 'English exam',
                                        placeholder: 'Select the exam given'
                                    },
                                    size: 'small'
                                } })) : null,
                            React.createElement("div", { className: "lfc-flex lfc-flex-col lfc-gap-2" },
                                examStatus !== EnglishExamStatusEnum.ENGLISH_EXAM_WAIVER && examType && (React.createElement(FFTextInput, { fieldProps: { name: formNames.englishTotalScore }, componentProps: {
                                        label: 'Total Score',
                                        placeholder: 'Enter Score',
                                        type: 'number',
                                        onInput: function () {
                                            triggerSectionEvent('Total Score', Inputype.RAW_INPUT);
                                        },
                                        size: 'small'
                                    } })),
                                examStatus === EnglishExamStatusEnum.GIVEN && examType && examType !== 'DUOLINGO' && (React.createElement("div", { className: "lfc-grid lfc-grid-cols-2 lfc-gap-2" },
                                    React.createElement(FFTextInput, { fieldProps: { name: formNames.listening }, componentProps: {
                                            label: 'Listening',
                                            placeholder: 'Enter score',
                                            type: 'number',
                                            onInput: function () {
                                                triggerSectionEvent('Listening', Inputype.RAW_INPUT);
                                            },
                                            size: 'small'
                                        } }),
                                    React.createElement(FFTextInput, { fieldProps: { name: formNames.reading }, componentProps: {
                                            label: 'Reading',
                                            placeholder: 'Enter score',
                                            type: 'number',
                                            onInput: function () {
                                                triggerSectionEvent('Reading', Inputype.RAW_INPUT);
                                            },
                                            size: 'small'
                                        } }),
                                    React.createElement(FFTextInput, { fieldProps: { name: formNames.speaking }, componentProps: {
                                            label: 'Speaking',
                                            placeholder: 'Enter score',
                                            type: 'number',
                                            onInput: function () {
                                                triggerSectionEvent('Speaking', Inputype.RAW_INPUT);
                                            },
                                            size: 'small'
                                        } }),
                                    React.createElement(FFTextInput, { fieldProps: { name: formNames.writing }, componentProps: {
                                            label: 'Writing',
                                            placeholder: 'Enter score',
                                            type: 'number',
                                            onInput: function () {
                                                triggerSectionEvent('Writing', Inputype.RAW_INPUT);
                                            },
                                            size: 'small'
                                        } }))),
                                examStatus === EnglishExamStatusEnum.GIVEN && examType && examType === 'DUOLINGO' && (React.createElement("div", { className: "lfc-grid lfc-grid-cols-2 lfc-gap-2" },
                                    React.createElement(FFTextInput, { fieldProps: { name: formNames.literacy }, componentProps: {
                                            label: 'Literacy',
                                            placeholder: 'Enter score',
                                            type: 'number',
                                            onInput: function () {
                                                triggerSectionEvent('Literacy', Inputype.RAW_INPUT);
                                            },
                                            size: 'small'
                                        } }),
                                    React.createElement(FFTextInput, { fieldProps: { name: formNames.comprehension }, componentProps: {
                                            label: 'Comprehension',
                                            placeholder: 'Enter score',
                                            type: 'number',
                                            onInput: function () {
                                                triggerSectionEvent('Comprehension', Inputype.RAW_INPUT);
                                            },
                                            size: 'small'
                                        } }),
                                    React.createElement(FFTextInput, { fieldProps: { name: formNames.production }, componentProps: {
                                            label: 'Production',
                                            placeholder: 'Enter score',
                                            type: 'number',
                                            onInput: function () {
                                                triggerSectionEvent('Production', Inputype.RAW_INPUT);
                                            },
                                            size: 'small'
                                        } }),
                                    React.createElement(FFTextInput, { fieldProps: { name: formNames.conversation }, componentProps: {
                                            label: 'Conversation',
                                            placeholder: 'Enter score',
                                            type: 'number',
                                            onInput: function () {
                                                triggerSectionEvent('Conversation', Inputype.RAW_INPUT);
                                            },
                                            size: 'small'
                                        } })))),
                            examStatus === EnglishExamStatusEnum.ENGLISH_EXAM_WAIVER ? (React.createElement(React.Fragment, null,
                                (props === null || props === void 0 ? void 0 : props.universityCodeOptionLoader) ? (React.createElement(React.Fragment, null,
                                    ' ',
                                    React.createElement(GBTypography, { variant: "sh2" }, "Bachelor's Degree"),
                                    React.createElement(FFAsyncDropdown, { fieldProps: { name: formNames.ugUniversityCode }, componentProps: {
                                            disableClearable: false,
                                            textInputProps: {
                                                label: 'University Name',
                                                placeholder: 'Select'
                                            },
                                            fetchOptionsHandler: props === null || props === void 0 ? void 0 : props.universityCodeOptionLoader,
                                            size: 'small'
                                        } }))) : null,
                                React.createElement(Divider, { className: "lfc-my-2" }),
                                React.createElement(GBTypography, { variant: "sh2" }, "12th/Diploma"),
                                React.createElement(FFDropdown, { fieldProps: { name: formNames.twelfthEnglishGradingScheme }, componentProps: {
                                        disableClearable: false,
                                        textInputProps: {
                                            label: 'Grading Scheme',
                                            placeholder: 'Select'
                                        },
                                        options: gradeOptions,
                                        renderOption: function (props, option) {
                                            var _a, _b;
                                            return (React.createElement("li", __assign({}, props), (_b = (_a = getModifiedGradeLabel(option)) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : ''));
                                        },
                                        size: 'small'
                                    } }),
                                (props === null || props === void 0 ? void 0 : props.twelfthBoardOptionLoader) ? (React.createElement(FFAsyncDropdown, { fieldProps: { name: formNames.twelfthBoardCode }, componentProps: {
                                        disableClearable: false,
                                        textInputProps: {
                                            label: 'Twelfth Board',
                                            placeholder: 'Select'
                                        },
                                        fetchOptionsHandler: props === null || props === void 0 ? void 0 : props.twelfthBoardOptionLoader,
                                        size: 'small'
                                    } })) : null,
                                React.createElement(FFTextInput, { fieldProps: { name: formNames.twelfthEnglishGrade }, componentProps: {
                                        type: 'number',
                                        label: 'Twelfth English Grade',
                                        placeholder: 'Enter grade',
                                        size: 'small',
                                        disabled: isFalsy(gradingScheme) || isFalsy(twelfthBoard),
                                        helperText: isFalsy(gradingScheme) && isFalsy(twelfthBoard)
                                            ? 'Please Select Grading Scheme and Board'
                                            : isFalsy(gradingScheme)
                                                ? 'Please Select Grading Scheme'
                                                : isFalsy(twelfthBoard)
                                                    ? 'Please select Board'
                                                    : ''
                                    } }),
                                (props === null || props === void 0 ? void 0 : props.twelfthGraduationYearOptions) ? (React.createElement(FFDropdown, { fieldProps: { name: formNames.twelfthGraduationYear }, componentProps: {
                                        disableClearable: false,
                                        textInputProps: {
                                            label: 'Twelfth Graduation Year',
                                            placeholder: 'Select'
                                        },
                                        options: (_g = props === null || props === void 0 ? void 0 : props.twelfthGraduationYearOptions) !== null && _g !== void 0 ? _g : [],
                                        size: 'small'
                                    } })) : null)) : null),
                        React.createElement("div", { className: "lfc-flex lfc-flex-col" },
                            React.createElement(Divider, null),
                            React.createElement("div", { className: "lfc-self-end lfc-p-2 lfc-flex lfc-gap-2" },
                                React.createElement(Button, { variant: "tertiary", onClick: function () {
                                        clearFilters();
                                    } }, "Clear"),
                                React.createElement(Button, { onClick: function () { return handleSubmit(); } }, "Apply")))));
                }, onSubmit: handleFormSubmit }))));
};
export default EnglishExamCFFilter;
//# sourceMappingURL=EnglishExamCFFilter.js.map